import eventHub from '@/scripts/eventHub';
import { Sprite, Texture } from 'pixi.js';
import Coin from '../actors/Coin';
import state from '../state';
import ticker from '../ticker';
import vars from '../vars';

class Coins {
  constructor(parent) {
    this.parent = parent;

    const emptyTexture = Texture.EMPTY;
    emptyTexture.orig.width = vars.layout.FRAME_WIDTH;
    emptyTexture.orig.height = vars.layout.FRAME_HEIGHT;
    this.container = new Sprite(emptyTexture);

    this.lastTime = ticker.totalTime;
    this.coins = [];

    this.frameHandler = () => { this.frame(); };
    this.spawnCoinHandler = (event) => { this.spawnCoin(event.x, event.y, event.type); };

    this.resize();
    this.parent.addChild(this.container);

    eventHub.$on('spawncoin', this.spawnCoinHandler);
  }

  resize() {}

  startSpawn() {
    ticker.add(this.frameHandler);
  }

  frame() {
    for (let i = this.coins.length - 1; i >= 0; i -= 1) {
      const coin = this.coins[i];
      coin.sprite.position.x -= state.foregroundSpeed * ticker.speed;

      if (coin.sprite.position.x < 0 - coin.sprite.width / 2) {
        coin.destroy();
        this.coins.splice(i, 1);
      }
    }
  }

  spawnCoin(x, y, type) {
    const coin = new Coin(this.container, x, y, type);
    this.coins.push(coin);
  }

  gameover() {
    ticker.remove(this.frameHandler);
    for (let i = this.coins.length - 1; i >= 0; i -= 1) {
      const coin = this.coins[i];
      coin.destroy();
      this.coins.splice(i, 1);
    }
  }

  replay() {
    this.lastTime = ticker.totalTime;
    ticker.add(this.frameHandler);
  }
}

export default Coins;
